import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Collapse, Column, Grid, GridItem, Row, Typography } from 'seagull';
import DiscountInput from "../ServiceCreation/ServiceBuilder/DiscountInput";
import MinPriceTextField from "../ServiceCreation/ServiceBuilder/MinPriceTextField";
import PriceTextField from "../ServiceCreation/ServiceBuilder/PriceTextField";
import PricingTextField from "../ServiceCreation/ServiceBuilder/PricingTextField";
import { getPriceAfterDiscount } from "../ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import UnitNameTextField from "../ServiceCreation/ServiceBuilder/UnitNameTextField";
import styles from "./ServicePriceEditorV2.module.scss";
import { getServicePriceEditorV2TID } from "./ServicePriceEditorV2.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServicePriceEditorV2PricingContent = _ref => {
  let {
    isBundle
  } = _ref;
  const {
    ServicePriceEditorV2TID
  } = useMemo(() => getServicePriceEditorV2TID(), []);
  const {
    watch
  } = useFormContext();
  const [pricing, price, minPrice, discount] = watch(['pricing', 'price', 'minPrice', 'discount']);
  const discountedPrice = useMemo(() => getPriceAfterDiscount({
    pricing,
    price,
    minPrice,
    discount
  }), [pricing, price, minPrice, discount]);
  return /*#__PURE__*/_jsxs(Column, {
    children: [/*#__PURE__*/_jsxs(Grid, {
      rowGap: 24,
      children: [/*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(PricingTextField, {
          isBundle: isBundle
        })
      }), pricing === 'unit' && /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(UnitNameTextField, {
          testid: ServicePriceEditorV2TID.UnitNameTextField()
        })
      }), pricing === 'range' && /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(MinPriceTextField, {
          testid: ServicePriceEditorV2TID.MinPriceTextField()
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(PriceTextField, {
          testid: ServicePriceEditorV2TID.PriceTextField(),
          isBundle: isBundle
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(DiscountInput, {
          testid: ServicePriceEditorV2TID.DiscountInput()
        })
      })]
    }), /*#__PURE__*/_jsx(Collapse, {
      in: Boolean(discountedPrice),
      children: /*#__PURE__*/_jsx(Row, {
        className: styles.priceAfterDiscount,
        "data-testid": ServicePriceEditorV2TID.PriceAfterDiscount(),
        children: /*#__PURE__*/_jsxs(Typography, {
          as: "span",
          children: ["Price after discount:", ' ', /*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            as: "span",
            children: discountedPrice
          })]
        })
      })
    })]
  });
};
export default ServicePriceEditorV2PricingContent;